"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("@alcumus/components");
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
const analytics_package_1 = __importDefault(require("@alcumus/analytics-package"));
const useStyles = (0, core_1.makeStyles)({
    icon: {
        '& .fas': {
            color: components_1.StyleVariables.colors.action.primary.default,
        },
        '& .far': {
            color: components_1.StyleVariables.colors.grey4,
        },
    },
});
const FavoriteButton = ({ liked, onFavourite, }) => {
    const classes = useStyles();
    const [isFavourite, setFavourite] = (0, react_1.useState)(liked ?? false);
    const shouldFavouriteItem = (wasFavourited) => {
        setFavourite(!wasFavourited);
        if (onFavourite)
            onFavourite(!wasFavourited);
        analytics_package_1.default.getInstance().trackWithCategory('Favourites', `${wasFavourited ? 'Un-favourited' : 'Favourited'} an item`);
    };
    const getCurrentIcon = () => {
        return isFavourite ? 'fas fa-heart' : 'far fa-heart';
    };
    return (react_1.default.createElement("span", { className: classes.icon, onClick: () => shouldFavouriteItem(isFavourite) },
        react_1.default.createElement("i", { className: getCurrentIcon() })));
};
exports.default = FavoriteButton;
